import { defineStore } from 'pinia'

interface AdminInfo {
  id: string
  username: string
  role: string
  email?: string
  nickname?: string
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '' as string,
    refreshToken: '' as string,
    mfaTicket: '' as string,
    mfaOK: false,
    admin: null as AdminInfo | null,
    menus: [] as string[],
  }),
  getters: {
    isLogin: (s) => !!s.token,
    hasRole: (s) => (role: string) => s.admin?.role === role,
  },
  actions: {
    hasMenu(code: string) {
      return this.menus.includes(code) || this.menus.includes('*')
    },
    setSession(s: {
      token: string
      refreshToken?: string
      mfaOK?: boolean
      admin: AdminInfo
      menus: string[]
    }) {
      this.token = s.token
      if (s.refreshToken) this.refreshToken = s.refreshToken
      this.mfaOK = s.mfaOK ?? true
      this.admin = s.admin
      this.menus = s.menus
      localStorage.setItem('admin_token', s.token)
      localStorage.setItem('admin_info', JSON.stringify(s.admin))
      localStorage.setItem('admin_menus', JSON.stringify(s.menus))
    },
    restoreSession() {
      try {
        const token = localStorage.getItem('admin_token')
        const adminStr = localStorage.getItem('admin_info')
        const menusStr = localStorage.getItem('admin_menus')
        if (token && adminStr && menusStr) {
          this.token = token
          this.admin = JSON.parse(adminStr)
          this.menus = JSON.parse(menusStr)
          this.mfaOK = true
        }
      } catch {
        this.logout()
      }
    },
    /** 从 /auth/me 拉取最新菜单（以 roles.permissions 为准，覆盖本地缓存） */
    async refreshMenus() {
      if (!this.token) return
      try {
        const { authApi } = await import('@/api/auth')
        const res: any = await authApi.me()
        if (res?.admin) this.admin = res.admin
        if (Array.isArray(res?.menus)) {
          this.menus = res.menus
          localStorage.setItem('admin_menus', JSON.stringify(res.menus))
        }
        if (res?.admin) {
          localStorage.setItem('admin_info', JSON.stringify(res.admin))
        }
      } catch {
        /* 保持本地缓存；401 由 http 拦截器处理登出 */
      }
    },
    async login(username: string, password: string) {
      const { authApi } = await import('@/api/auth')
      const res = await authApi.login({ username, password })
      this.setSession(res)
      return res
    },
    logout() {
      this.token = ''
      this.refreshToken = ''
      this.mfaTicket = ''
      this.mfaOK = false
      this.admin = null
      this.menus = []
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
      localStorage.removeItem('admin_menus')
    },
  },
})